import { render } from "./InfoRcu.vue?vue&type=template&id=a02dff2a&scoped=true"
import script from "./InfoRcu.vue?vue&type=script&lang=js"
export * from "./InfoRcu.vue?vue&type=script&lang=js"

import "./InfoRcu.vue?vue&type=style&index=0&id=a02dff2a&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a02dff2a"]])

export default __exports__